<template>
  <div class="page_wrapper container-fluid job_opening_area">
    <div class="row page_header job_opening_header">
      <job-opening-header title-en="Job Opening"/>
    </div>
    <div class="row job_opening_content">
      <job-opening-en-content />
    </div>
  </div>
</template>
<script>
import JobOpeningHeader from '~components/pages/job-opening/JobOpeningHeader'
import JobOpeningEnContent from '~components/pages/job-opening/EnContent'
export default {
  name: 'JobOpeningEn',
  routerName: 'Job-openingEn',
  components: {
    JobOpeningHeader,
    JobOpeningEnContent
  }
}
</script>
